import { BASE_COLORS, LAYOUT, media } from "config/theme/constants";
import { Layout } from "antd";
import styled, { css } from "styled-components";

interface FooterType {
  $isTwoColumnsLayoutHeader: boolean;
}

export const Footer = styled(Layout.Footer)<FooterType>`
  line-height: 1.5;
  background: ${BASE_COLORS.selago};
  border-top: 1px solid ${BASE_COLORS.altolight};
  text-align: center;
  font-size: 12px;

  .footer-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }

  @media only screen and ${media.md} {
    padding: ${LAYOUT.desktop.paddingVertical}
      ${LAYOUT.desktop.paddingHorizontal};
    height: ${LAYOUT.desktop.footerHeight};
  }

  @media only screen and ${media.md} {
    ${(props) =>
      props?.$isTwoColumnsLayoutHeader &&
      css`
        padding: 0;
      `}
  }
`;
